document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.dataset.quoteThankYou) return;
  var params = new URLSearchParams(window.location.search);
  var rawValue = parseFloat(params.get('value'));
  if (isNaN(rawValue)) rawValue = 1;
  // Quotify's event.detail.price comes through in cents, not dollars (confirmed
  // 2026-07-16: $2099.85 quote recorded as $209,985.00, an exact 100x match).
  // Convert to dollars, then report 20% of quote value as the tracked conversion
  // value, reflecting expected close rate rather than full quote value.
  var quoteValue = (rawValue / 100) * 0.2;
  if (typeof gtag === 'function') {
    gtag('event', 'conversion', {
      'send_to': 'AW-845525146/vho5COX9irEYEJrhlpMD',
      'value': quoteValue,
      'currency': 'USD'
    });
  }
});